import React from "react";
import withStyles from "components/with-styles";
import styles from "./styles/profile-username.css.js";

const ProfileUsername = ({ classes, children }) => <p className={classes.userMenuText}>{children}</p>;

export default withStyles(styles)(ProfileUsername);
